import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { withABTestContext } from '../../ab-test-context';
import { withProductContext } from '../product-router';
import { initialisationExperience } from '../../../common/ufo-experiences';
export var InitialisationExperienceSuccessInner = function InitialisationExperienceSuccessInner(_ref) {
  var id = _ref.id,
    abTest = _ref.abTest,
    getPrimaryProduct = _ref.getPrimaryProduct;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    successCalled = _useState2[0],
    setSuccessCalled = _useState2[1];
  useEffect(function () {
    if (successCalled) {
      return;
    }
    var primaryProduct = getPrimaryProduct();
    if (abTest && primaryProduct && primaryProduct.id === id) {
      initialisationExperience.success();
      setSuccessCalled(true);
    }
  }, [abTest, getPrimaryProduct, id, successCalled]);
  return null;
};

/**
 * This component calls the success method on the UFO initialisation
 * experience when AB test data exists. There is an assumption that when
 * there is a registered primary product in the product router state, it has
 * finished loading, i.e. this component should only be rendered after any
 * asynchronous loading of a product tab.
 */
export var InitialisationExperienceSuccess = withABTestContext(withProductContext(InitialisationExperienceSuccessInner));